import { useState, useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

export const Notification = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onClose, 300); // Wait for animation to complete
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const getIcon = () => {
    return type === 'success' ? (
      <CheckCircle className="w-5 h-5 text-green-500" />
    ) : (
      <XCircle className="w-5 h-5 text-red-500" />
    );
  };

  const getBackgroundColor = () => {
    return type === 'success' 
      ? 'bg-green-50 border-green-200 dark:bg-green-900/20 dark:border-green-800'
      : 'bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800';
  };

  const getTextColor = () => {
    return type === 'success'
      ? 'text-green-800 dark:text-green-200'
      : 'text-red-800 dark:text-red-200';
  };

  return (
    <div
      className={`fixed top-4 right-4 z-[10500] max-w-sm w-full transform transition-all duration-300 ${
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
      }`}
    >
      <div className={`p-4 rounded-lg border ${getBackgroundColor()} shadow-lg`}>
        <div className="flex items-start space-x-3">
          {getIcon()}
          
          <div className="flex-1">
            <p className={`text-sm font-medium ${getTextColor()}`}>
              {message}
            </p>
          </div>
          
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors duration-200"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}; 